import { ShieldCheck, Scale, Landmark, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { useLang } from "../i18n/i18n";

export default function Trust() {
  const { t } = useLang();
  const CARDS = [
    { icon: ShieldCheck, tt: "trust.c1t", dd: "trust.c1d" },
    { icon: Scale, tt: "trust.c2t", dd: "trust.c2d" },
    { icon: Landmark, tt: "trust.c3t", dd: "trust.c3d" },
  ];

  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-8 py-24" data-testid="trust-section">
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase text-gold">{t("trust.eyebrow")}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-light text-cream max-w-2xl leading-tight">
          {t("trust.title1")} <em className="gold-text italic font-medium">{t("trust.title2")}</em> {t("trust.title3")}
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.tt} delay={0.08 * i} className="h-full">
            <div className="group h-full rounded-2xl border border-gold/15 bg-panel/70 p-8 transition-all hover:border-gold/40 hover:bg-panel2 hover:-translate-y-1 duration-300">
              <c.icon size={28} className="text-gold" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-xl text-cream">{t(c.tt)}</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/60">{t(c.dd)}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <a
          href="https://www.encansdesparois.com"
          target="_blank"
          rel="noreferrer"
          data-testid="trust-auctions-link"
          className="mt-6 group flex items-center justify-between rounded-2xl border border-gold/15 bg-panel/50 overflow-hidden hover:border-gold/40 transition-all"
        >
          <div className="px-8 py-7">
            <p className="font-display text-xl sm:text-2xl text-cream">{t("trust.auctions")}</p>
            <p className="mt-1.5 text-sm text-mutedc">{t("trust.auctionsSub")}</p>
          </div>
          <span className="px-8 text-gold transition-transform group-hover:translate-x-1 group-hover:-translate-y-1">
            <ArrowUpRight size={26} />
          </span>
        </a>
      </Reveal>
    </section>
  );
}
